import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {


    constructor(private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let logged = false;
        if (sessionStorage.getItem('currentUser')) {
            // logged in so return true
            const roles = JSON.parse(sessionStorage.getItem('currentUserRoles'));
            // console.log(roles);

            const mainUserRole = sessionStorage.getItem('mainUserRole');
            if ('ADMIN' !== mainUserRole) {
                switch (state.url) {
                    case '/creance':
                        if (roles.includes('RESPONSABLE_FINANCIER')) {
                            logged = true;
                        }
                        break;
                    case '/operations/credit-enlevement':
                        if (roles.includes('RESPONSABLE_FINANCIER')) {
                            logged = true;
                        }
                        break;
                    case '/compte-echu':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/litige':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/titres-change':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;

                    case '/demande/soumettre-demande':
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/demande/consulter-demande':
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/demande/completer-demande':
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/declaration-mlv':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/declaration-d19-mlv':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/creances-payees':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/delai':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/h-edocument':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;

                    default:
                        break;
                }
                if (roles && roles.length > 0) {
                    logged = true;
                } else {
                    logged = false;
                }
            } else {
                logged = true;
            }
        }

        if (sessionStorage.getItem('newSessionId') === localStorage.getItem('oldSessionId')) {
            const roles = JSON.parse(sessionStorage.getItem('currentUserRoles'));
            const mainUserRole = sessionStorage.getItem('mainUserRole');

            // console.log(roles);
            if ('ADMIN' !== mainUserRole) {
                switch (state.url) {
                    case '/creance':
                        if (roles.includes('RESPONSABLE_FINANCIER')) {
                            logged = true;
                        }
                        break;
                    case '/operations/credit-enlevement':
                        if (roles.includes('RESPONSABLE_FINANCIER')) {
                            logged = true;
                        }
                        break;
                    case '/compte-echu':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/litige':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/titres-change':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/demande/soumettre-demande':
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/demande/consulter-demande':
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/demande/completer-demande':
                        if (roles.includes('RESPONSABLE_ADMINISTRATIF_JURIDIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/declaration-mlv':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/declaration-d19-mlv':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/creances-payees':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/delai':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;
                    case '/historique/h-edocument':
                        if (roles.includes('RESPONSABLE_LOGISTIQUE')) {
                            logged = true;
                        }
                        break;

                    default:
                        break;
                }
                if (roles && roles.length > 0) {
                    logged = true;
                } else {
                    logged = false;
                }
            } else {
                logged = true;
            }
        } else {
            logged = false;
        }


        // not logged in so redirect to login page
        if (!logged) {
            this.router.navigate(['/home'], { queryParams: { returnUrl: state.url } });
        }
        return logged;
    }

    simpleStringify(object) {
        var simpleObject = {};
        for (var prop in object) {
            if (!object.hasOwnProperty(prop)) {
                continue;
            }
            if (typeof (object[prop]) == 'object') {
                continue;
            }
            if (typeof (object[prop]) == 'function') {
                continue;
            }
            simpleObject[prop] = object[prop];
        }
        return JSON.stringify(simpleObject); // returns cleaned up JSON
    };
}
